module.exports = __webpack_public_path__ + "static/media/icomoon.e49ce0f3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon/icomoon.ttf?24fgiz
// module id = 2939
// module chunks = 0